export enum AnonymityLevel {
  "ANONYMOUS" = "ANONYMOUS",
  "CONFIDENTIAL" = "CONFIDENTIAL",
  "PUBLIC" = "PUBLIC",
  "ANONYMIZE_PARTICIPANT_RESULTS" = "ANONYMIZE_PARTICIPANT_RESULTS",
}
